import React, { useState, useEffect } from "react"
import { nanoid } from "nanoid"

import { fbAuth } from "../../services/Firebase"
import { Swiper, SwiperSlide,  } from "swiper/react"
import SwiperCore, { EffectCoverflow, Pagination } from "swiper"
import "swiper/swiper-bundle.min.css"
import RecipeSlide from "./RecipeSlide"
import RecipePage from "../../pages/recipe/RecipePage"
import Service from "../../services/Service"

SwiperCore.use([ EffectCoverflow, Pagination ])

function RecipeCarousel({ allRecipes, showRecipe, setShowWine }) {
    const [ recipes, setRecipes ] = useState([])
    const [ showPage, setShowPage ] = useState( false )
    const [ favRecipes, setFavRecipes ] = useState([])
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }

    useEffect(() => {
        const dataset = Service.getDataFromLS( `${user.uid}-recipes` )
        setFavRecipes( dataset )
    }, [ user.uid ])

    useEffect(() => {
        const getRecipe = () => setRecipes(allRecipes)
        getRecipe()
    }, [ allRecipes ])

    const displayPage = () => {
        showPage ? setShowPage( false ) : setShowPage( true )
        setShowWine( prevState => !prevState )
    }

    return (
        <> 
            {
                showPage 
                    ?   <RecipePage 
                        allRecipes={recipes} 
                        displayPage={displayPage} />
                    :   showRecipe 
                &&  <article className="carousel">
                    <h2>Recipe of the Day</h2>
                    <Swiper
                        effect="coverflow"
                        pagination={{ clickable: true }}
                        spaceBetween={30}
                        slidesPerView={1}
                        loop="true"
                    >
                        {
                            recipes.map( recipe => {
                                return  <SwiperSlide key={nanoid()}>
                                    <RecipeSlide 
                                        recipe={recipe} 
                                        displayPage={displayPage}
                                        favRecipes={favRecipes}
                                        setFavRecipes={setFavRecipes}
                                    />
                                </SwiperSlide>
                            })
                        }
                    </Swiper>
                </article>
            } 
        </>
    )
}

export default RecipeCarousel
